import create from 'zustand'

type RolexTrackingScriptStore = {
  scriptIsLoaded: boolean
  setScriptIsLoaded: () => void
}

const useRolexTrackingScriptStore = create<RolexTrackingScriptStore>((set) => ({
  scriptIsLoaded: false,
  setScriptIsLoaded: () => set({ scriptIsLoaded: true }),
}))

export function useRolexTrackingScript() {
  const store = useRolexTrackingScriptStore()

  return store
}
